import DashboardLayout from "src/Modules/Users/Layouts/DashboardLayout.vue";

// Page Headers
import DefaultHeader from "src/Modules/Users/Pages/DefaultHeader";

// Pages
import Recipes from 'src/Modules/Health/Pages/Recipes';
import Recipe from 'src/Modules/Health/Pages/Recipe';

const routes = [
    {
        path: '/Health/Recipes',
        component: DashboardLayout,
        children: [
            {
                path: '',
                name: 'Recipes',
                components: { default: Recipes, header: DefaultHeader },
                meta: { authOnly: true }
            },
            {
                path: ':slug',
                name: 'Recipes - Recipe',
                components: { default: Recipe, header: DefaultHeader },
                meta: { authOnly: true }
            },
            {
                path: ':id(\\d+)',
                name: 'Recipes - Recipe By ID',
                components: { default: Recipe, header: DefaultHeader },
                meta: { authOnly: true }
            },
            {
                path: 'WholeMeals/:Meal*',
                name: 'Recipes - Whole Meal',
                components: { default: Recipes, header: DefaultHeader },
                meta: { authOnly: true }
            },
            {
                path: 'Meal/:Meal',
                name: 'Recipes - Meal',
                components: { default: Recipes, header: DefaultHeader },
                meta: { authOnly: true }
            },
        ]
    }
];

export default routes;
